import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Constants from "../../../constants";
import { getAPIService } from "../../API";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetails } from "../../../actions";
import OrderDetailsContainer from "./OrderDetailsContainer";
import { getDate } from "../../../utils";
import TrackPackage from "../../Shared/TrackPackage";
import ShipToContainer from "./ShipToContainer";
import OrderDetailsContainerNew from "./OrderDetailsContainer/indexnew";

// Styled Components
const StyledContainer = styled.div`
  
  
  width: 97vw;
  min-height: 100vh;
  overflow-x: hidden;

  background-color: #f5f5f5;

  font-family: 'Ancizar Sans', sans-serif;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;

`;
const InnerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `
const StyledOrderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
  min-height: 100px;
  margin-top:7rem;
  max-width: 1200px;
  padding: 1rem 1.6rem;
`;
const OrderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;

  .return-exchange{

  cursor: pointer;
  width: 51px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  span {
  
    color: rgb(31, 31, 30);
    border: 1px solid rgb(55, 56, 54);
    width: 3px;
    height: 3px;
    border-radius: 50%;
    margin: 1px 1px;
    display: inline-block;
    }

  }

`;
const OrderOnTypography = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 30px;
background-color:rgb(128, 211, 39);
color: #fff;
padding: 0 16px;
font-size: 14px;
font-family:Ancizar Sans, sans-serif;
border-radius: 4px;
`
const OrderNumberTypography = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 14px;
font-family:Ancizar Sans, sans-serif;
color: #555;
padding: 0 16px;
font-weight: 700;
`
const InvoiceButton = styled.button`
display: flex;
justify-content: center;
align-items: center;
height: 30px;
border:1px solid rgb(134, 134, 134);
norder-radius: 4px;
font-size: 14px;
font-family:Ancizar Sans, sans-serif;
outline: none;
background-color: transparent;

margin-left: auto;
border-radius: 4px;
cursor: pointer;
`
const OrderMainCont = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: flex-start;
margin-top: 1rem;
border-bottom: 1px solid #e0e0e0;
padding-bottom: 16px;

`
const PaymentModeContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
font-size: 1rem;
font-family: 'Ancizar Sans', sans-serif;

`

const AllOrderListContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
font-size: 1rem;
font-family: 'Ancizar Sans', sans-serif;

`

const CancelOrReturnModel = styled.button`
 position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  border: 1px solid rgba(134, 134, 134, 0.3);
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Ancizar Sans', sans-serif;
  outline: none;
  cursor: pointer;
  padding: 8px 12px;
  margin-left: 8px;
  min-width: 200px;
  min-height: 220px;

 
`;

const CancelOrderItem = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  font-family: 'Ancizar Sans', sans-serif;
  font-size: 1rem;
  padding: 1rem;
  background-color: #fff;
  color: rgb(31, 31, 30);
  border-radius: 8px;

  &&:hover {
    background-color: rgb(93, 239, 31);
    
    color: #fff;
    
    cursor: pointer;
  }

`



const OrderDetailsNew = () => {
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const orderNumQuery = searchParams.get("orderId");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const orderDetails = useSelector(
    (state) => state.orderDetails?.orderDetailData || {}
  );
  const {
    orderDate = "",
    orderNumber = "",
    orderReleaseList = [],
    shipToAddress = {},
  } = orderDetails;
  const { city = "", state = "", pinCode = "" } = shipToAddress;
  const shipmentEvents =
    (orderReleaseList?.length > 0 && orderReleaseList?.[0]?.shipmentEvents) ||
    [];
  useEffect(() => {
    const getOrderDetailsAPI = async () => {
      const URL = `${Constants.orders.getOrderDetails}?orderNumber=${orderNumQuery}`;
      getAPIService({ url: URL }).then((response) => {
        const { status = 100, data = {} } = response;
        dispatch(getOrderDetails(data));
      });
    };
    getOrderDetailsAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNumQuery]);

  const handleDrawer = () => {
    setOpen(true);
  };


  console.log(city, state, pinCode, "shipToAddress in OrderDetailsNew");


  const emailToAdmins = (type) => {
    //redirect to gmail to send email to admins

    let subject = `Order ${type} Request`;
    let body = `Hello Admin,\n\nI would like to request the ${type.toLowerCase()} of my order with Order Number: ${orderNumber}.\n\nThank you.`;
    window.location.href = `mailto:info@blazestore.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;


  }



  return (
    <React.Fragment>
      <StyledContainer>
        <StyledOrderContainer>
          <OrderTop>
              
              <OrderOnTypography>{`${orderDate}`}</OrderOnTypography>
              <InvoiceButton >
                Invoice
              </InvoiceButton>
              <OrderNumberTypography>{`Order #${orderNumber}`}</OrderNumberTypography>
              <div className="return-exchange" onClick={() => setIsModelOpen(true)}>
                <span></span>
                 <span></span>
                  <span></span>

              </div>
          </OrderTop>
          <OrderMainCont>
            <ShipToContainer shipToAddress={shipToAddress} />
            <PaymentModeContainer>
              {"Payment Mode"}: <span>{`Prepaid UPI`}</span>
            </PaymentModeContainer>
          </OrderMainCont>
          <AllOrderListContainer>
            {orderReleaseList.length > 0 && (
              <OrderDetailsContainerNew
                orderReleaseList={orderReleaseList}
                orderNumber={orderNumber}
              />
            )}
          </AllOrderListContainer>

          {isModelOpen && <> <CancelOrReturnModel onMouseLeave={() => setIsModelOpen(false)}>

            <CancelOrderItem onClick={() => emailToAdmins("Cancel")}>Cancel Order</CancelOrderItem>
             <CancelOrderItem onClick={() => emailToAdmins("Return")}>Return Order</CancelOrderItem>
              <CancelOrderItem onClick={() => emailToAdmins("Help")}>Request Help</CancelOrderItem>


        </CancelOrReturnModel ></>}


        </StyledOrderContainer>
       
      </StyledContainer>
    </React.Fragment>
  );
};

export default OrderDetailsNew;
